import {ArrowRight, Ruler, Tag} from 'lucide-react'

function Hero() {
  return (
    <div className="relative overflow-hidden">
      {/* Glow backdrop */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
      >
        <div className="absolute -top-32 left-1/4 h-72 w-72 rounded-full bg-indigo-600/20 blur-3xl" />
        <div className="absolute -top-20 right-1/4 h-72 w-72 rounded-full bg-emerald-500/15 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-5 pb-12 pt-16 md:pt-24">
        <div className="animate-fade-up max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-500/10 px-3 py-1 font-mono text-xs font-medium text-emerald-300">
            <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" />
            Interactive logo calculator suite
          </span>
          <h1 className="mt-5 font-display text-4xl font-bold leading-[1.1] tracking-tight text-white md:text-6xl">
            The{' '}
            <span className="bg-gradient-to-r from-indigo-400 to-emerald-400 bg-clip-text text-transparent">
              logo calculator
            </span>{' '}
            built for designers & brands
          </h1>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-400">
            Estimate logo pricing, solve safe margins and aspect ratios, and decode the famous Vans
            square-root skateboard formula — all in one fast, pixel-perfect workspace.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="#pricing"
              className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-indigo-500 to-emerald-400 px-5 py-3 text-sm font-semibold text-[#070a13] shadow-lg shadow-indigo-500/30 transition-transform hover:scale-105"
            >
              <Tag className="h-4 w-4" />
              Estimate logo pricing
              <ArrowRight className="h-4 w-4" />
            </a>
            <a
              href="#aspect"
              className="inline-flex items-center gap-2 rounded-xl border border-white/10 bg-white/[0.03] px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-white/10"
            >
              <Ruler className="h-4 w-4" />
              Solve aspect ratios
            </a>
          </div>

          <dl className="mt-10 grid max-w-lg grid-cols-3 gap-4">
            {[
              { k: '3', v: 'Live calculators' },
              { k: '0', v: 'Sign-up required' },
              { k: '∞', v: 'Free estimates' },
            ].map((stat) => (
              <div key={stat.v} className="rounded-xl border border-white/8 bg-white/[0.02] px-4 py-3">
                <dt className="font-mono text-2xl font-bold text-indigo-300">{stat.k}</dt>
                <dd className="mt-0.5 text-xs text-slate-400">{stat.v}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}

export default Hero
